import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArSS: CultureInfo = {
  name: 'ar-SS',
  displayName: 'العربية (جنوب السودان)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-SS',
  parent: CultureInfoAr
};
